// Copyright: IQGeo Limited 2010-2019
import _ from 'underscore';
import $ from 'jquery';
import myw from 'myWorld/base/core';
import 'myWorld/base/controlOwnerMixin';
import 'myWorld/controls/geoMapControl';

myw.Layout = myw.Control.extend({
    includes: myw.ControlOwnerMixin,
    options: {
        GeoMapControl: myw.GeoMapControl,
        v: 2 //options format version
    },

    /**
     * @class Layout for a standard web browser client environment.
     * This includes desktop computers, laptops and tablets.
     * The registered controls will be instantiated when the layout is applied.
     * When layout sections are resized (either by a window resize or by collapsing/expanding sections), controls will be informed
     * via a call to method 'invalidateSize()' (if they implement it). This allows the controls to set sizes of internal elements (ie. for scrolling)
     * @param {desktopLayoutOptions} options
     * @constructs
     * @mixes {ControlOwnerMixin}
     */
    initialize(owner, options) {
        myw.Control.prototype.initialize.call(this, owner, options);

        this.controls = {};

        this.initialized = this.initUI();
    },

    /**
     * Initializes the layout's UI components
     * @return {Promise<GeoMapControl>}
     */
    initUI() {
        const map = new this.options.GeoMapControl(this.app, this.el);
        return Promise.resolve(map);
    },

    /**
     * Instantiates the controls and setups user event handlers
     * @return {promise} To be resolve when all the controls have been instantiated and initialized
     */
    initControls() {
        const controlsState = this.options.controlsState;
        // add a scale bar to map
        L.control.scale().addTo(this.app.map);

        //instantiate the controls
        _.each(this.options.controls, (controlDef, key) => {
            if (controlDef) {
                /* jshint newcap: false */
                const controlClass = controlDef[0];

                let options = controlDef[1];
                const savedState = controlsState && controlsState[key];

                options = _.extend(options, savedState);
                this.controls[key] = new controlClass(this.app, options);
            }
        });

        //wait for controls to be initialized before continuing
        return Promise.all(_.pluck(this.controls, 'initialized')).then(() => {
            // //convert all divs identified with button class into jquery buttons,
            // //all html should have been loaded before this executed
            // //ENH: each control should handle buttons themselves, making this unnecessary
            // $(".button").button();

            this.initUserEventHandlers();
            this.initAppEventHandlers();

            this.app.map.invalidateSize(); //is this still necessary?
        });
    },

    /**
     * Displays an image in a pop-up dialog
     * @param  {string}         title        Title for the dialog
     * @param  {jqueryElement}  imgElement   Element for the image to be displayed
     */
    displayImage(title, imgElement) {
        const widgetWidth = $(window).outerWidth() - 50;
        const widgetHeight = $(window).outerHeight() - 50;

        const imageContainer = $('<div/>', { class: 'photo-container' }).append(imgElement);

        imageContainer.find('img').on('load', () => {
            imageContainer.dialog({
                title: title,
                width: 'auto',
                maxHeight: widgetHeight,
                maxWidth: widgetWidth
            });
        });
        return imageContainer;
    },

    getState() {
        return {
            controlsState: this.getChildrenState(),
            v: 2
        };
    },

    //upgrades options from pre 4.2 to the 4.2 format
    upgradeOptionsToV2: function(options) {
        //pre 4.2 sub controls state was saved in hierarchy (tabControl had state of sub-ontrols).
        //From 4.2 all controls are saved at top-level
        const ctlsState = options.controlsState;
        if (ctlsState && ctlsState.tabControl) {
            _.extend(ctlsState, ctlsState.tabControl.tabsState);
            delete options.controlsState.tabControl;
        }
        return options;
    },

    /**
     * Initializes the handlers for user events (mouse clicks, etc...)
     * override in subclasses
     */
    initUserEventHandlers() {},

    /**
     * Initializes the handlers for application events (current feature changes, etc...)
     * override in subclasses
     */
    initAppEventHandlers() {},

    //overridden to  sub-elements
    remove() {
        this.app.map.remove();
        //ENH: call remove on controls
        myw.Control.prototype.remove.call(this);
    }
});

/**
 * Options to specify when creating a Layout
 * @typedef layoutOptions
 * @property {string}                       mapDivId   Id of the div where the main map should be created
 * @property {object<controlDefinition>}    controls   Control definitions, keyed on control name
 */

export default myw.Layout;
